import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navigation from "./components/common/Navigation";
import { WithAuthAndProgress } from "./components/hoc/withAuthAndProgress";
import ActivitiesPage from "./components/pages/ActivitiesPage";
import ActivityDetailPage from "./components/pages/ActivityDetailPage";
import DashboardPage from "./components/pages/DashboardPage";
import ConnectStravaPage from "./components/pages/ConnectStravaPage";
import HomePage from "./components/pages/HomePage";
import InitializationFailedPage from "./components/pages/InitializationFailedPage";
import LoginCallback from "./components/pages/LoginCallbackPage";
import NotFoundPage from "./components/pages/NotFoundPage";
import ProfilePage from "./components/pages/ProfilePage";
import SettingsPage from "./components/pages/SettingsPage";
import StravaLoginCallbackPage from "./components/pages/StravaLoginCallbackPage";
import { useAuth } from "./contexts/authContext";
import { useUser } from "./contexts/userContext";
import * as routes from "./routes";

const Main = () => {
  const location = useLocation();
  const { userHasLoggedIn } = useAuth();
  const { user, initializeUserAsync, hasInitializationFailed } = useUser();

  useEffect(() => {
    if (userHasLoggedIn() && user === null && !hasInitializationFailed) {
      // Don't retry if initialization has failed
      initializeUserAsync(false);
    }
  }, [userHasLoggedIn, initializeUserAsync, user, hasInitializationFailed]);

  if (hasInitializationFailed) {
    return <InitializationFailedPage />;
  }

  return (
    <Flex minH="100vh" w="100%" direction={{ base: "column", md: "row" }}>
      {/* Conditionally render Navigation based on the path */}
      {location.pathname !== routes.HOME_PAGE &&
        location.pathname !== routes.LOGIN_CALLBACK_PAGE &&
        location.pathname !== routes.NOT_FOUND_PAGE && <Navigation />}

      {/* Main Content Area */}
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        flex="1"
        p={{ base: "1rem", md: "2rem" }}
        minH="100vh"
      >
        <Routes>
          <Route path={routes.HOME_PAGE} element={<WithAuthAndProgress component={HomePage} />} />
          <Route path={routes.LOGIN_CALLBACK_PAGE} element={<LoginCallback />} />
          <Route
            path={routes.DASHBOARD_PAGE}
            element={<WithAuthAndProgress component={DashboardPage} />}
          />
          <Route
            path={routes.ACTIVITIES_PAGE}
            element={<WithAuthAndProgress component={ActivitiesPage} />}
          />
          <Route
            path={routes.ACTIVITY_DETAIL_PAGE}
            element={<WithAuthAndProgress component={ActivityDetailPage} />}
          />
          <Route
            path={routes.SETTINGS_PAGE}
            element={<WithAuthAndProgress component={SettingsPage} />}
          />
          <Route
            path={routes.PROFILE_PAGE}
            element={<WithAuthAndProgress component={ProfilePage} />}
          />
          <Route
            path={routes.CONNECT_STRAVA_PAGE}
            element={<WithAuthAndProgress component={ConnectStravaPage} />}
          />
          <Route path={routes.STRAVA_LOGIN_CALLBACK_PAGE} element={<StravaLoginCallbackPage />} />
          <Route path={routes.NOT_FOUND_PAGE} element={<NotFoundPage />} />
        </Routes>
      </Flex>
    </Flex>
  );
};

export default Main;
